/**
 * URL parameter utilities
 * @module shared-cart/utils/url
 */

/**
 * Removes a query parameter from the current URL without page reload
 * @param {string} param - The parameter name to remove
 */
export function removeUrlParam(param: string): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState({}, document.title, url.toString());
}

/**
 * Extracts the handoff parameter from the current URL
 * @returns {string|null} The handoff parameter value or null if not present
 */
export function getHandoffParam(): string | null {
  return new URLSearchParams(window.location.search).get('handoff');
}
